import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      onClick={toggleTheme}
      data-testid="theme-toggle-btn"
      title={dark ? "Modo claro" : "Modo oscuro"}
      className="relative p-2 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors"
    >
      <span className="block transition-transform duration-300" style={{ transform: dark ? "rotate(180deg)" : "rotate(0deg)" }}>
        {dark ? <Sun size={17} /> : <Moon size={17} />}
      </span>
    </button>
  );
}
